<template>
  <div class="login_main_container">
    <div class="bg_box">
      <div class="login_box">
        <div class="login_title">
          <img class="logo" src="../../assets/img/jll_logo_rgb.svg" />
          <div class="line"></div>
          <div class="title gray size-30">
            {{ titleLabel }}
          </div>
        </div>
        <div class="login_tab"></div>
        <div class="login_form">
          <login-form
            :user="user"
            :isLogining="isLogining"
            :isSending="isSending"
            :btntxt="btntxt"
            @login="login"
            @sendvercode="sendvercode"
            @forgetPassword="forgetPassword"
          ></login-form>
        </div>
        <el-dialog
          width="30%"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :visible.sync="promptVisible"
          center
        >
          <span v-html="vercodeTips" ></span>
          <span slot="footer" class="dialog-footer">
            <el-button plain @click="promptVisible = false">
              {{ confirm }}
            </el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <div style="position: absolute;right:1%;top:65px;">
      <span>SAMEX Systems eTendering Support Hotline (<a class="app_logout" href="http://www.samexsys.com" target="_blank" style="text-decoration:underline">www.samexsys.com</a>):
       +852 8111 4290 &nbsp;| <a class="app_logout" href="mailto:support@samexsys.com" style="text-decoration:underline">support@samexsys.com</a>
              <a class="app_logout" href="https://youtu.be/P6fehD0mjWM" target="_blank" style="text-decoration:underline"><b>Click Here for User Manual</b></a>
            </span>
    </div>
  </div>
</template>
<script>
import LoginForm from "../../components/form/LoginForm";
import { getUrlParam, encrypt } from "../../utils/utils";
import { token, postRequest } from "../../utils/api";
export default {
  data() {
    return {
      isLogining: false,
      isSending: false,
      btntxt: "",
      time: 0,
      user: {
        // loginid: "fusen",
        // password: "123456",
        loginid: "",
        password: "",
        logintype: "0",
        langcode: "",
        vercode: "",
        isremember: false
      },
      titleLabel: 'Supplier Portal Login',
      promptVisible: false,
      vercodeTips: "",
      confirm: "OK",
    };
  },
  mounted() {
    this.init();
  },
  components: {
    LoginForm
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.init();
  },
  computed: {

  },
  methods: {
    changeLang(lang) {
      let _this = this;
      _this.$i18n.locale = lang;
    },
    init() {
      this.gettips();
      //this.getUserIp();
      let lang = getUrlParam("langcode");
      if (lang) {
        this.changeLang(lang.toUpperCase());
      } else {
        this.changeLang("EN");
      }
      //this.$alert("后端已注销，请重新登陆！");
      //console.log(sessionStorage.getItem('ip'));
      
    },
    // getUserIp(){
    //   const s = document.createElement('script');
    //   s.type = 'text/javascript';
    //   s.src = 'http://pv.sohu.com/cityjson?ie=utf-8';
    //   document.body.appendChild(s);
    //   const ip = returnCitySN['cip'];
    //   console.log(ip);
    // },
    login() {
      let _this = this;
      _this.isLogining = true;
      _this.user.langcode = _this.$i18n.locale;
      _this
        .loginHandle(_this.user)
        .then(res => {
          if (res.success) {
            //console.log(res);
            // let sessionid = res.sessionid;
            let hrid = res.hrid;
            let siteid = res.siteid;
            let emailverified = res.emailverified;
            let issupplier = res.issupplier;
            let maxsessionid = res.maxsessionid;
            sessionStorage.setItem("maxsessionid",maxsessionid);
            if (_this.user.isremember) {
              _this.$cookies.set("login_id", _this.user.loginid, "");
              _this.$cookies.set("login_pwd", encrypt(_this.user.password));
            } else {
              _this.$cookies.remove("login_id");
              _this.$cookies.remove("login_pwd");
            }
            _this.$store.commit("user/setLanguage", _this.user.langcode);
            _this.$store.commit("user/setHrid", hrid);
            _this.$store.commit("user/setSiteId", siteid);
            _this.$store.commit("user/setEmailverified", emailverified);
            _this.$store.commit("user/setIsSupplier", issupplier);
            if(!emailverified){
              _this.$store.commit("user/setIsFirstLogin","1");
            }
            _this.$router.replace({
              path: "/"
            });
          } else {
            // _this.$message.error(this.$t("warning_pageText.LOGINFAILED"));
             _this.$message.error(res.message);
            _this.isLogining = false;
          }
        })
        .catch(error => {
          _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
          _this.isLogining = false;
        });
    },
    loginHandle(user) {
      return new Promise((resolve, reject) => {
        postRequest("userLogin", {
          token: token,
          loginid: user.loginid,
          password: user.password,
          logintype: user.logintype,
          code: user.vercode,
          clienthost: (!sessionStorage.getItem('ip') || sessionStorage.getItem('ip')=="") ? '127.0.0.1' : sessionStorage.getItem('ip'),
        })
          .then(res => {
            let datas = res.data;
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    sendvercodeHandle(user) {
      return new Promise((resolve, reject) => {
        postRequest("getVercode", {
          suppliername : user.loginid,
          password : user.password,
          isforget : false
        })
          .then(res => {
            let datas = res.data;
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    sendvercode(){
      let _this = this; 
      _this.user.langcode = _this.$i18n.locale;
      _this
        .sendvercodeHandle(_this.user)
        .then(res => {
          if (res.success) {
           _this.isSending = true;
           _this.promptVisible = true;
           //console.log('successsss');
           _this.time = 900;
           _this.timer();
          } else {
            _this.isSending = false;
            _this.promptVisible = false;
            _this.$message.error(res.message);
            //console.log('errorrrrrr');
          }
        })
        .catch(error => {
          _this.isSending = false;
          _this.promptVisible = false;
          //console.log(error);
        });
    },
    timer(){
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + " " + this.$t("login_pageText.RESEND");
        setTimeout(this.timer, 1000);
      } else {
          this.time = 0;
          // this.btntxt = "获取验证码";
          this.isSending = false;
      }
    },
    forgetPassword(){
      let _this = this; 
      _this.$router.replace({
              path: "/forgetpassword"
      });
      //console.log(_this.$router);
    },
    gettips(){
      return postRequest("getList",{
        reqname: "gettips",
      })
      .then(res => {
        if(res.data.success){
          //console.log(res.data.gettips[0].message);
          this.vercodeTips = res.data.gettips[0].message;
        }
      })
      .catch(error => {
          
        })
      .finally(() => {

      });
    },
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.titleLabel = 'Supplier Portal Login';
    }
  }
};
</script>
<style scoped>
.login_main_container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 700px; */
  height: 100%;
  background: url("../../assets/img/bg.png") no-repeat;
  background-size: cover;
  overflow: hidden;
}

.bg_box {
  width: 100%;
  padding: 10px;
  overflow: hidden;
  box-sizing: border-box;
}

.login_title {
  padding: 10px 30px 0 30px;
  text-align: center;
}

.login_title > .logo {
  width: 132px;
  margin-bottom: 20px;
}

.login_title > .line {
  width: 400px;
  height: 2px;
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    #bababa,
    rgba(255, 255, 255, 0)
  );
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    #bababa,
    rgba(255, 255, 255, 0)
  );
  margin: 0 auto;
}

.login_title > .title {
  margin: auto;
  padding: 20px 0 30px 0;
}

.login_box {
  width: 600px;
  /* height: 400px; */
  background-color: #fffc;
  -webkit-box-shadow: 0 0 10px #bababa;
  box-shadow: 0 0 10px #bababa;
  border-radius: 8px;
  border: 1px solid #ddd;
  margin: 0 auto;
  padding: 20px 10px;
  box-sizing: border-box;
}

.login_form {
  margin: 0 auto;
}

.tab_group {
  width: 420px;
  height: 45px;
  margin: 43px auto 0;
}

.tab-button {
  width: 158px;
  height: 45px;
  border: 0;
  cursor: pointer;
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  text-align: center;
  color: #666;
}
.app_logout {
  padding: 5px;
}
.app_logout:link{
  color:#000000;
}
.app_logout:hover,
.app_logout:active {
  color: #a50606;
}

.tab-button:hover {
}

.tab-button:active {
}

.tab-button:focus {
  outline: 0;
}

.active {
  color: #ffa000;
  border-bottom: 3px solid #ffa000;
  border-radius: 0;
  vertical-align: top;
}

.tab {
  border: 1px solid #ccc;
  padding: 10px;
}
</style>
